module.exports = __webpack_public_path__ + "static/media/landing-kitty11.668420d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty11.svg
// module id = 124
// module chunks = 0